import customAxios from "./axiosConfig";

const GekkoService = {
  getCurrencyOptions () {
    const api_url = window.Urls['invoice-get-currency-options']()
    return customAxios.get(api_url).then((response) => {
      return response.data.map(([code, name, symbol]) => ({ code, name, symbol }))
    })
  }
};

export default GekkoService;